<template>
  <Modal
    :value="visible"
    @on-cancel="cancelHandler"
    :title="nodeDetail && nodeDetail.id ? '编辑条件节点' : '增加条件节点'"
    width="500"
    footer-hide
  >
    <Form :model="formData" ref="form" :label-width="110" :rules="ruleValidate">
      <FormItem label="节点名称" prop="name">
        <Input v-model="formData.name" placeholder="" />
      </FormItem>
      <form-item-condition-outs  v-model="formData.outs" :formItemProps="{ prop: 'outs' }"/>
      <div class="btn">
        <Button style="margin-right: 20px" color="#547ed1" @click="cancelHandler">取消</Button>
        <Button
          type="primary"
          style="margin-right: 20px"
          color="#547ed1"
          @click="submit"
        >
          确定
        </Button>
      </div>
    </Form>
  </Modal>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { addNodeId } from '@/utils/nodeIdPool';
import FormItemConditionOuts from '../../../components/FormItemConditionOuts.vue';

export default {
  components: {
    FormItemConditionOuts,
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeDetail: {
      type: Object,
    }
  },
  data() {
    return {
      title: '',
      formData: {
        name: '',
        outs: [],
      },
      ruleValidate: {
        name: [
          { required: true, message: '节点名不能为空', trigger: 'blur' },
        ],
      }
    };
  },
	watch: {
		nodeDetail(val) {
			if (!val) {
        this.resetFormData();
        return;
      }
      this.formData = {
        ...this.formData,
        ...cloneDeep(val)
      }
		}
	},
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const formData = {
          ...cloneDeep(this.formData),
          type: 'condition',
        }
        if(this.formData.id) {
          this.$emit('editNode', formData)
        } else {
          this.$emit('addNode', formData)
        }
        this.cancelHandler();
      })
    },
    cancelHandler() {
      try {
        this.resetFormData();
      } catch (error) {
        // 改成多段录音后 form.resetFields 后报错
        console.log('error :>> ', error);
      }
      this.$emit('change', false)
      this.$emit('cancel');
    },
    resetFormData() {
      this.$refs.form.resetFields()
      this.formData = {
        name: '',
        outs: [],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  text-align: right;
}
.vars-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
}
.var-line {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
.var-form {
	flex: 1;
}
.var-del-icon {
	margin-left: 10px;
	font-size: 16px;
}
</style>